// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Copyright (c) 2025 Robert Schiwon
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 * the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

sf-parameters-panel {
  font-family: sans-serif;
  display: flex;
  flex: 0 1 100%;
  flex-direction: column;
  border: solid black 1px;
  border-radius: 5px;
  /* do not allow child elements to overlap rounded corners */
  overflow: hidden;
  background-color: #fff;
}

sf-parameters-panel > h1 {
  font-size: 1em;
  font-weight: normal;
  line-height: 2em;
  margin: 0;
  padding: 0 0.5em 0 0.5em;
  background-color: #eee;
}

sf-parameters-panel > h1.populated {
  font-weight: bold;
}

sf-parameters-panel div {
  display: flex;
  flex: 0 1 100%;
  flex-direction: column;
  overflow: auto;
  padding: 0.25em;
}

sf-parameters-panel div ul {
  font-size: 14px;
  margin: 0;
  padding-left: 0;
  margin-left: 1em;
  white-space: pre-wrap;
}
`, "",{"version":3,"sources":["webpack://./src/components/parameters/ParametersPanel.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;EAmBE;;AAEF;EACE,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,2DAA2D;EAC3D,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB","sourcesContent":["/**\n * Copyright (c) 2025 Robert Schiwon\n *\n * Permission is hereby granted, free of charge, to any person obtaining a copy of\n * this software and associated documentation files (the \"Software\"), to deal in\n * the Software without restriction, including without limitation the rights to\n * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of\n * the Software, and to permit persons to whom the Software is furnished to do so,\n * subject to the following conditions:\n *\n * The above copyright notice and this permission notice shall be included in all\n * copies or substantial portions of the Software.\n *\n * THE SOFTWARE IS PROVIDED \"AS IS\", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS\n * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR\n * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER\n * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN\n * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.\n */\n\nsf-parameters-panel {\n  font-family: sans-serif;\n  display: flex;\n  flex: 0 1 100%;\n  flex-direction: column;\n  border: solid black 1px;\n  border-radius: 5px;\n  /* do not allow child elements to overlap rounded corners */\n  overflow: hidden;\n  background-color: #fff;\n}\n\nsf-parameters-panel > h1 {\n  font-size: 1em;\n  font-weight: normal;\n  line-height: 2em;\n  margin: 0;\n  padding: 0 0.5em 0 0.5em;\n  background-color: #eee;\n}\n\nsf-parameters-panel > h1.populated {\n  font-weight: bold;\n}\n\nsf-parameters-panel div {\n  display: flex;\n  flex: 0 1 100%;\n  flex-direction: column;\n  overflow: auto;\n  padding: 0.25em;\n}\n\nsf-parameters-panel div ul {\n  font-size: 14px;\n  margin: 0;\n  padding-left: 0;\n  margin-left: 1em;\n  white-space: pre-wrap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
